import { Suspense, lazy } from 'react';

/**
 * `CreateCompanyDialog`, loaded the first time someone opens it.
 *
 * The top bar's company menu and profile menu are on every page, and importing the dialog directly
 * put it — with the full terms text it shows (`TermsBody`) — into the app's first load for every
 * person, though only a few ever click "+ New company". Rendered only while open, so its form
 * starts empty each time.
 */
const CreateCompanyDialog = lazy(() =>
  import('./CreateCompanyDialog.js').then((m) => ({ default: m.CreateCompanyDialog })),
);

export function LazyCreateCompanyDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <CreateCompanyDialog open onClose={onClose} />
    </Suspense>
  );
}
